import { MdmPolicyCommand } from "@devices/types";

/**
 * Gives every rule a key that survives a reorder: its own JSON, numbered when the same rule appears again.
 */
export const getRowKeys = (content: MdmPolicyCommand[]): string[] => {
    const seen = new Map<string, number>();

    return content.map((command) => {
        const identity = JSON.stringify(command);
        const occurrence = seen.get(identity) ?? 0;
        seen.set(identity, occurrence + 1);

        return occurrence === 0 ? identity : `${identity}#${occurrence}`;
    });
};
